import React from 'react';
import { useSelector } from 'react-redux';

import AccountForm from './AccountForm';
import {
  saveOrganizationRequest,
} from '../../../store/modules/organizations/actions';
import { useActionDispatcher } from '../../../hooks';
import { selectOrganization } from '../../../store/modules/organizations/selectors';

const OrganizationEdit = () => {

  const organization = useSelector(selectOrganization);
  const saveOrganization = useActionDispatcher(saveOrganizationRequest);

  return (
    <AccountForm
      record={organization}
      onSubmit={saveOrganization}
    />
  );
};

export default OrganizationEdit;
